import { useSelector } from "react-redux";
import {BrowserRouter, Routes, Route,Navigate} from "react-router-dom"
import HomePage from "./HomePage/HomePage";
import LoginPage from "./LoginPage/LoginPage";
import ProfilePage from "./ProfilePage/ProfilePage";
function App() {
  const {token}=useSelector((state)=>state.app)
  const {mode}=useSelector((state)=>state.app)
  return (
    <div className={mode ? "dark":""} >
    <div className="w-full h-[100vh] dark:bg-[#3D3B3B]">
    <BrowserRouter>
      <Routes>
        <Route path="/" element={token?(<HomePage/>):(<LoginPage/>)}/>
        <Route path="/home" element={token?(<HomePage/>):(<Navigate to="/"/>)}/>
        <Route path="/profile/:userId" element={token?(<ProfilePage/>):(<Navigate to="/"/>)}/>
      </Routes>
    </BrowserRouter>
    </div>
    </div>
  );
}

export default App;
